export default __webpack_public_path__ + "static/media/empty.051172c1.svg";